/**
 * useBulkResolution — the resolution engine for the AI Actions list.
 *
 * A thin composing facade over three focused sub-hooks, split out of what
 * used to be a single 513-line hook so each concern is reviewable in
 * isolation:
 *  - useBulkResolutionCache: optimistic removal from every list cache,
 *    partial-failure restore, and the non-refetching invalidation.
 *  - useBulkResolutionCompletion: post-resolve advance navigation.
 *  - useBulkResolutionSelection: the approvingTier / pendingApprove /
 *    pendingDismiss selection state machine, and the approve/dismiss
 *    execution that ties the other two together.
 */
import type { ProposalListItem } from '@/lib/proposals/core/types';

import { useBulkResolutionSelection } from './useBulkResolutionSelection';

interface UseBulkResolutionArgs {
  orgId: number | undefined;
  /** The pending list response — the selection resolves against it. */
  results: ProposalListItem[] | undefined;
}

export function useBulkResolution({ orgId, results }: UseBulkResolutionArgs) {
  return useBulkResolutionSelection({ orgId, results });
}
